// Initialize all product-related functionality when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    initProductGallery();
    initFeaturedProductCarousel();
    initSecondaryNavSticky();
    initProductVariantSelection();
    initProductAddToCart();
    initVideoLoadingStates();
});

function checkRecharge(productForm) {
    const rechargeWidget = productForm.querySelector('recharge-subscription-widget');
    if (!rechargeWidget) {
        return;
    } else {
        
        setTimeout(() => {
            const price = getRechargePrice(rechargeWidget);
            if(!price)return;
            const addToCartButton = productForm?.querySelector('.product-options-add-to-cart');
            const qtyInput = productForm?.querySelector('.product-options-qty-input');

            if (addToCartButton && qtyInput) {
                const quantity = parseInt(qtyInput.value, 10) || 1;
                const totalPrice = price * quantity;
                const [integerNumber, decimalNumber] = totalPrice.toFixed(2).split('.');
                const formattedTotal = `$${insertComma(integerNumber)}.${decimalNumber}`;
                addToCartButton.textContent = `Add to Cart – ${formattedTotal}`;
            }
        }, 100);
    }
    
}

document.addEventListener('variant:change', function(event) {
  const productForm = event.target; 
  checkRecharge(productForm);
});

document.addEventListener('click', function(event) {
    console.log(event.target)
    if (event.target.matches('recharge-subscription-widget')) {
        const productForm = event.target.closest('.product-options-form');
        if (productForm) {
            checkRecharge(productForm);
        }
    }
});


// Product Gallery Functionality
function initProductGallery() {
    const galleries = document.querySelectorAll('[data-product-gallery]');
    
    galleries.forEach(gallery => {
        const images = gallery.querySelectorAll('.product-gallery-image');
        const prevBtn = gallery.querySelector('[data-gallery-prev]');
        const nextBtn = gallery.querySelector('[data-gallery-next]');
        const indexDisplay = gallery.querySelector('[data-gallery-index]');
        
        if (images.length <= 1) return;
        
        let currentIndex = 0;
        const totalImages = images.length;
        let isAnimating = false;
        
        updateButtonColors(images[0]);
        
        function updateGallery(direction = 'next') {
            if (isAnimating) return;
            isAnimating = true;
            
            const currentImage = images[currentIndex];
            const previousIndex = direction === 'next' 
                ? (currentIndex - 1 + totalImages) % totalImages 
                : (currentIndex + 1) % totalImages;
            const previousImage = images[previousIndex];
            
            if (direction === 'next') {
                gsap.set(currentImage, { x: '100%', opacity: 1 });
                gsap.set(previousImage, { x: '0%', opacity: 1 });
            } else {
                gsap.set(currentImage, { x: '-100%', opacity: 1 });
                gsap.set(previousImage, { x: '0%', opacity: 1 });
            }
            
            const tl = gsap.timeline({
                onComplete: () => {
                    isAnimating = false;
                    updateButtonColors(currentImage);
                }
            });
            
            tl.to(previousImage, {
                x: direction === 'next' ? '-100%' : '100%',
                duration: 0.8,
                ease: "power2.inOut"
            }).to(currentImage, {
                x: '0%',
                duration: 0.8,
                ease: "power2.inOut"
            }, 0);
            
            images.forEach((img, index) => {
                if (index === currentIndex) {
                    img.classList.add('active');
                } else {
                    img.classList.remove('active');
                }
            });
            
            if (indexDisplay) {
                indexDisplay.textContent = `(${currentIndex + 1}/${totalImages})`;
            }
        }
        
        function updateButtonColors(imageElement) {
            if (!imageElement || !gsap) return;
            
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = new Image();
            let textColor = '#ffffff';
            let hoverColor = '#cccccc';
            
            img.crossOrigin = 'anonymous';
            
            img.onload = function() {
                try {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    
                    const sampleAreas = [
                        { x: 0, y: img.height * 0.7, w: img.width, h: img.height * 0.3 },
                        { x: 0, y: 0, w: img.width, h: img.height * 0.3 },
                        { x: 0, y: 0, w: img.width, h: img.height }
                    ];
                    
                    let totalBrightness = 0;
                    let sampleCount = 0;
                    let validSamples = 0;
                    
                    for (let area of sampleAreas) {
                        try {
                            const imageData = ctx.getImageData(area.x, area.y, area.w, area.h);
                            const data = imageData.data;
                            
                            for (let i = 0; i < data.length; i += 80) {
                                const r = data[i];
                                const g = data[i + 1];
                                const b = data[i + 2];
                                const a = data[i + 3];
                                
                                if (a > 128) {
                                    const brightness = (r * 0.299 + g * 0.587 + b * 0.114);
                                    totalBrightness += brightness;
                                    validSamples++;
                                }
                                sampleCount++;
                            }
                            
                            if (validSamples > 10) break;
                        } catch (e) {
                            console.warn('Error sampling image area:', e);
                            continue;
                        }
                    }
                    
                    if (validSamples > 0) {
                        const averageBrightness = totalBrightness / validSamples;
                        textColor = averageBrightness > 128 ? '#000000' : '#ffffff';
                        hoverColor = averageBrightness > 128 ? '#666666' : '#cccccc';
                        console.log('Color detection result:', {
                            averageBrightness,
                            textColor,
                            validSamples,
                            totalSamples: sampleCount
                        });
                    } else {
                        console.warn('No valid color samples found, using fallback');
                    }
                } catch (e) {
                    console.error('Error in color detection:', e);
                }
                
                const controls = gallery.querySelector('.product-gallery-controls');
                if (controls) {
                    gsap.to(controls, {
                        color: textColor,
                        duration: 0.6,
                        ease: "power2.inOut"
                    });
                }
                
                gallery.style.setProperty('--button-text-color', textColor);
                gallery.style.setProperty('--button-hover-color', hoverColor);
                canvas.remove();
            };
            
            img.onerror = function() {
                console.warn('Failed to load image for color detection, using fallback');
                const controls = gallery.querySelector('.product-gallery-controls');
                if (controls) {
                    gsap.to(controls, {
                        color: textColor,
                        duration: 0.6,
                        ease: "power2.inOut"
                    });
                }
                gallery.style.setProperty('--button-text-color', textColor);
                gallery.style.setProperty('--button-hover-color', hoverColor);
            };
            
            img.src = imageElement.src;
        }
        
        function nextImage() {
            if (isAnimating) return;
            currentIndex = (currentIndex + 1) % totalImages;
            updateGallery('next');
        }
        
        function prevImage() {
            if (isAnimating) return;
            currentIndex = (currentIndex - 1 + totalImages) % totalImages;
            updateGallery('prev');
        }
        
        if (prevBtn) {
            prevBtn.addEventListener('click', prevImage);
        }
        
        if (nextBtn) {
            nextBtn.addEventListener('click', nextImage);
        }
        
        gallery.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                prevImage();
            } else if (e.key === 'ArrowRight') {
                nextImage();
            }
        });
        
        let startX = 0;
        let endX = 0;
        
        gallery.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });
        
        gallery.addEventListener('touchend', (e) => {
            endX = e.changedTouches[0].clientX;
            const diff = startX - endX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    nextImage();
                } else {
                    prevImage();
                }
            }
        });
        
        updateGallery('next');
    });
}

// Featured Product Carousel Functionality
function initFeaturedProductCarousel() {
    const carousels = document.querySelectorAll('.featured-product-carousel[data-product-gallery], .related-products-carousel[data-product-gallery]');
    console.log('Found product carousels:', carousels.length);
    
    carousels.forEach((carousel, carouselIndex) => {
        const slides = carousel.querySelectorAll('.carousel-slide');
        const nextBtn = carousel.querySelector('[data-gallery-next]');
        const indexDisplay = carousel.querySelector('[data-gallery-index]');
        
        console.log(`Carousel ${carouselIndex}: Found ${slides.length} slides`);
        
        if (slides.length <= 1) {
            console.log(`Carousel ${carouselIndex}: Not enough slides, skipping`);
            return;
        }
        
        let currentIndex = 0;
        const totalSlides = slides.length;
        let isAnimating = false;
        let autoPlayInterval = null;
        let isAutoPlaying = false;
        
        slides.forEach((slide, index) => {
            if (index === 0) {
                slide.classList.add('active');
                gsap.set(slide, { x: '0%', opacity: 1 });
            } else {
                slide.classList.remove('active');
                gsap.set(slide, { x: '100%', opacity: 1 });
            }
        });
        
        function startAutoPlay() {
            if (isAutoPlaying || totalSlides <= 1) return;
            isAutoPlaying = true;
            autoPlayInterval = setInterval(() => {
                if (!isAnimating) {
                    nextSlide();
                }
            }, 2500);
        }
        
        function stopAutoPlay() {
            if (!isAutoPlaying) return;
            isAutoPlaying = false;
            if (autoPlayInterval) {
                clearInterval(autoPlayInterval);
                autoPlayInterval = null;
            }
        }
        
        function updateCarousel(direction = 'next') {
            if (isAnimating) return;
            isAnimating = true;
            
            const currentSlide = slides[currentIndex];
            const previousIndex = direction === 'next' 
                ? (currentIndex - 1 + totalSlides) % totalSlides 
                : (currentIndex + 1) % totalSlides;
            const previousSlide = slides[previousIndex];
            
            console.log(`Updating carousel: current=${currentIndex}, previous=${previousIndex}, direction=${direction}`);
            
            if (direction === 'next') {
                gsap.set(currentSlide, { x: '100%', opacity: 1 });
                gsap.set(previousSlide, { x: '0%', opacity: 1 });
            } else {
                gsap.set(currentSlide, { x: '-100%', opacity: 1 });
                gsap.set(previousSlide, { x: '0%', opacity: 1 });
            }
            
            const tl = gsap.timeline({
                onComplete: () => {
                    isAnimating = false;
                    console.log('Animation complete');
                }
            });
            
            tl.to(previousSlide, {
                x: direction === 'next' ? '-100%' : '100%',
                duration: 0.8,
                ease: "power2.inOut"
            }).to(currentSlide, {
                x: '0%',
                duration: 0.8,
                ease: "power2.inOut"
            }, 0);
            
            slides.forEach((slide, index) => {
                if (index === currentIndex) {
                    slide.classList.add('active');
                } else {
                    slide.classList.remove('active');
                }
            });
            
            if (indexDisplay) {
                indexDisplay.textContent = `(${currentIndex + 1}/${totalSlides})`;
            }
        }
        
        function nextSlide() {
            if (isAnimating) return;
            currentIndex = (currentIndex + 1) % totalSlides;
            updateCarousel('next');
        }
        
        function prevSlide() {
            if (isAnimating) return;
            currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
            updateCarousel('prev');
        }
        
        if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                console.log('Next button clicked');
                stopAutoPlay();
                nextSlide();
            });
        }
        
        let startX = 0;
        let endX = 0;
        
        carousel.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });
        
        carousel.addEventListener('touchend', (e) => {
            endX = e.changedTouches[0].clientX;
            const diff = startX - endX;
            if (Math.abs(diff) > 50) {
                stopAutoPlay();
                if (diff > 0) {
                    nextSlide();
                } else {
                    prevSlide();
                }
            }
        });
        
        setTimeout(() => {
            startAutoPlay();
        }, 2000);
    });
}

// Secondary Navigation Sticky Functionality
function initSecondaryNavSticky() {
    const stickySections = document.querySelectorAll('[data-sticky]');
    if (stickySections.length === 0) return;
    
    stickySections.forEach(section => {
        const sectionRect = section.getBoundingClientRect();
        const sectionTop = section.offsetTop;
        let isFixed = false;
        
        function handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const viewportTop = scrollTop;
            
            if (viewportTop >= sectionTop && !isFixed) {
                section.classList.add('fixed');
                isFixed = true;
            } else if (viewportTop < sectionTop && isFixed) {
                section.classList.remove('fixed');
                isFixed = false;
            }
        }
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
    });
}


// Recharge Price Extraction
function getRechargePrice(rechargeWidget) {
    // Access shadow DOM if elements are encapsulated
    const root = rechargeWidget.shadowRoot || rechargeWidget;
    const oneTimeOption = root.querySelector('.rc-selection__onetime');
    const subscriptionOption = root.querySelector('.rc-purchase-option__subscription');

    if (oneTimeOption && subscriptionOption) {
        const isSubscriptionSelected = subscriptionOption.hasAttribute('rc-selected');
        let priceText = ''
        if (isSubscriptionSelected) {
            const subscriptionPrice = subscriptionOption.querySelector('.rc-price')
            priceText = subscriptionPrice?.textContent;
        } else {
            const oneTimePrice = oneTimeOption.querySelector('.rc-price')
            priceText = oneTimePrice?.textContent;
        }
        const priceMatch = priceText.match(/\$\s*([\d,]+\.?\d*)/);
        if (priceMatch) {
            const price = parseFloat(priceMatch[1].replace(',', ''));
            return price;
        }
    }
}

// Product Variant Selection Functionality
function initProductVariantSelection() {
    setTimeout(() => {
        const productForms = document.querySelectorAll('.product-options-form');
        
        productForms.forEach(form => {
            const sizeRadios = form.querySelectorAll('.product-size-radio');
            const sizeLabels = form.querySelectorAll('.product-size-label');
            const addToCartButton = form.querySelector('.product-options-add-to-cart');
            const purchasePrice = form.querySelector('.purchase-price');
            const qtyInput = form.querySelector('.product-options-qty-input');
            
            function updateAddToCartPrice() {
                const selectedRadio = form.querySelector('.product-size-radio:checked');
                
                if (selectedRadio && addToCartButton && qtyInput) {
                    const variantPrice = selectedRadio.dataset.variantPrice;
                    const quantity = parseInt(qtyInput.value, 10) || 1;
                    const maxQuantity = parseInt(selectedRadio.getAttribute('quantity'));

                    if (!addToCartButton.hasAttribute('coming-soon')) {
                        if (addToCartButton.hasAttribute('pre-order')) {
                            const priceMatch = variantPrice.match(/[\d,]+\.?\d*/);
                            if (priceMatch) {
                                const numericPrice = parseFloat(priceMatch[0].replace(',', ''));
                                const totalPrice = numericPrice * quantity;
                                const [integerNumber, dicemalNumber] = totalPrice.toFixed(2).split('.');
                                const formattedTotal = `$${insertComma(integerNumber)}.${dicemalNumber}`;
                                addToCartButton.textContent = `Pre-Order – ${formattedTotal}`;
                                addToCartButton.classList.remove('sold-out');
                                addToCartButton.removeAttribute('disabled');
                            }
                        } else {
                            if (maxQuantity > 0) {
                                const priceMatch = variantPrice.match(/[\d,]+\.?\d*/);
                                if (priceMatch) {
                                    const numericPrice = parseFloat(priceMatch[0].replace(',', ''));
                                    const totalPrice = numericPrice * quantity;
                                    const [integerNumber, dicemalNumber] = totalPrice.toFixed(2).split('.');
                                    const formattedTotal = `$${insertComma(integerNumber)}.${dicemalNumber}`;
                                    addToCartButton.textContent = `Add to Cart – ${formattedTotal}`;
                                    addToCartButton.classList.remove('sold-out');
                                    addToCartButton.removeAttribute('disabled');
                                }
                            } else {
                                addToCartButton.textContent = 'Sold Out';
                                addToCartButton.classList.add('sold-out');
                                addToCartButton.setAttribute('disabled', true);
                            }
                        }
                    }
                }
            }
            
            sizeRadios.forEach(radio => {
                radio.addEventListener('change', function() {
                    sizeLabels.forEach(label => {
                        label.classList.remove('selected');
                    });
                    
                    const label = form.querySelector(`label[for="${this.id}"]`);
                    if (label) {
                        label.classList.add('selected');
                    }
                    
                    updateAddToCartPrice();
                    
                    if (purchasePrice && this.dataset.variantPrice) {
                        purchasePrice.textContent = this.dataset.variantPrice;
                    }
                    
                    // Dispatch custom variant:change event
                    const variantData = {
                        id: this.value,
                        price: this.dataset.variantPrice,
                        available: parseInt(this.getAttribute('quantity')) > 0
                    };
                    const variantChangeEvent = new CustomEvent('variant:change', {
                        detail: { variant: variantData },
                        bubbles: true
                    });
                    form.dispatchEvent(variantChangeEvent);
                });
            });

            checkRecharge(form)
            
            initProductQuantitySelector(form, updateAddToCartPrice);
        });
    }, 1000);
}

// Product Quantity Selector Functionality
function initProductQuantitySelector(form, updatePriceCallback) {
    const minusBtn = form.querySelector('.product-options-qty-minus');
    const plusBtn = form.querySelector('.product-options-qty-plus');
    const qtyInput = form.querySelector('.product-options-qty-input');
    
    if (minusBtn && plusBtn && qtyInput) {
        minusBtn.addEventListener('click', function() {
            let currentQty = parseInt(qtyInput.value, 10);
            if (currentQty > 1) {
                qtyInput.value = currentQty - 1;
                if (updatePriceCallback) {
                    updatePriceCallback();
                }
                qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
        
        plusBtn.addEventListener('click', function() {
            let currentQty = parseInt(qtyInput.value, 10);
            qtyInput.value = currentQty + 1;
            if (updatePriceCallback) {
                updatePriceCallback();
            }
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
        qtyInput.addEventListener('change', function() {
            let value = parseInt(this.value, 10);
            if (isNaN(value) || value < 1) {
                this.value = 1;
            }
            if (updatePriceCallback) {
                updatePriceCallback();
            }
        });
        
        qtyInput.addEventListener('blur', function() {
            let value = parseInt(this.value, 10);
            if (isNaN(value) || value < 1) {
                this.value = 1;
            }
            if (updatePriceCallback) {
                updatePriceCallback();
            }
        });
    }
}

// Reset Product Form Functionality
function resetProductForm(form) {
    const sizeRadios = form.querySelectorAll('.product-size-radio');
    const sizeLabels = form.querySelectorAll('.product-size-label');
    const addToCartButton = form.querySelector('.product-options-add-to-cart');
    const qtyInput = form.querySelector('.product-options-qty-input');
    
    if (qtyInput) {
        qtyInput.value = 1;
    }
    
    sizeRadios.forEach(radio => {
        radio.checked = false;
    });
    
    sizeLabels.forEach(label => {
        label.classList.remove('selected');
    });
    
    if (addToCartButton) {
        addToCartButton.textContent = 'Add to Cart';
        addToCartButton.disabled = false;
    }
}

// Product Add to Cart Functionality
function initProductAddToCart() {
    setTimeout(() => {
        document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
            if (form.hasAttribute('data-cart-update-listener')) {
                return;
            }
            
            form.setAttribute('data-cart-update-listener', 'true');
            const atcButton = form.querySelector('.product-options-add-to-cart');
            
            atcButton.addEventListener('click', (e) => {
                if (atcButton.classList.contains('sold-out') || atcButton.hasAttribute('disabled')) {
                    e.preventDefault();
                }
            });
            
            form.addEventListener('submit', async function() {
                setTimeout(async () => {
                    try {
                        const res = await fetch('/cart.js');
                        const cart = await res.json();
                        await updateCartDrawer();
                        updateCartCount(cart.item_count);
                        openCartDrawer();
                    } catch (error) {
                        console.error('Error updating cart:', error);
                    }
                }, 1000);
            });
        });
    }, 1000);
}

// Insert Comma Helper Function
function insertComma(integerNumber) {
    if (typeof integerNumber != 'number') {
        integerNumber = parseInt(integerNumber);
        if (isNaN(integerNumber)) {
            return '';
        }
    }
    
    const str = integerNumber.toString();
    let result = '';
    let len = str.length;
    
    while (len > 0) {
        if (result !== '') {
            result = `,${result}`;
        }
        
        if (len > 3) {
            result = str.substring(len - 3, len) + result;
            len -= 3;
        } else {
            result = str.substring(0, len) + result;
            len = 0;
        }
    }
    
    return result;
}

// Video Loading States Functionality
function initVideoLoadingStates() {
    const videoIframes = document.querySelectorAll('iframe[src*="vimeo.com"], iframe[src*="youtube.com"]');
    
    videoIframes.forEach(iframe => {
        iframe.classList.add('loading');
        
        iframe.addEventListener('load', function() {
            setTimeout(() => {
                iframe.classList.remove('loading');
                iframe.classList.add('loaded');
            }, 500);
        });
        
        iframe.addEventListener('error', function() {
            iframe.classList.remove('loading');
            iframe.classList.add('error');
        });
        
        setTimeout(() => {
            if (iframe.classList.contains('loading')) {
                iframe.classList.remove('loading');
                iframe.classList.add('loaded');
            }
        }, 3000);
    });
}